export function throwError (err) {
  if (err instanceof Error) {
    throw err
  }

  throw new Error(
    typeof err === 'string' ? err : JSON.stringify(err)
  )
}
